import {createRoot, hydrateRoot} from 'react-dom/client';
import Intelligence from '../pages/Intelligence/Intelligence'
import "../index.css";
import "../pages/Intelligence/Intelligence.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<Intelligence {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <Intelligence {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).IntelligenceVC = {mount, hydrate, unmount}